import { Col, Container, Row } from "react-bootstrap";
import "./companyProfile.scss";
import { useEffect, useRef } from "react";
import useGoogleMaps from "../../hooks/useGoogleMaps";
import axios from "axios";

const CompanyProfilePage: React.FC = () => {
  const mapRef = useRef(null);
  useGoogleMaps();

  useEffect(() => {
    let browserWindow: any = window;
    // let location: { lat: number; lng: number } = {
    //   lat: 40.12150192260742,
    //   lng: -100.45039367675781,
    // };
    console.log("Browser window ", window);
    let locationName = "Kowdiya, Thiruvanathapuram";
    let apiKey = "AIzaSyBg8bhJnUaTelc-IyKQ41sLQE9GpqvYzkE";
    // https://maps.googleapis.com/maps/api/geocode/json?address=${locationName}&key=${apiKey}
    //`https://maps.googleapis.com/maps/api/geocode/json?address=${locationName}&key=${apiKey}`

    axios
      .get(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${locationName}&key=${apiKey}`,
        { headers: {} }
      )
      .then((response: any) => {
        try {
          let data = response.data;
          if(data.error_message) {
            console.error("Error fetching location data: ", data.error_message);
            return;
          }
          const location = response.data.results[0].geometry.location;
          console.log("Location : ", location);
          if (browserWindow.google) {
            const map = new browserWindow.google.maps.Map(mapRef.current, {
              center: location,
              zoom: 16,
            });

            new browserWindow.google.maps.Marker({
              position: location,
              map: map,
              title: "Hello World!",
            });
          }
        } catch (error) {
          console.error("Error fetching location data: ", error);
        }
      });
  }, []);

  return (
    <section className="company-profile">
      <Container fluid className="company-profile__container-wrapper">
        <Row>
          <Col lg={12} md={12} xs={12} className="company-profile-wrapper">
            <div className="left-header">
              <span className="back"></span>
              <span className="header-text">Company profile</span>
            </div>

            {/* <div className="right-header">
                <span className="search"></span>
                <span className="more"></span>
                <span className="upload">Upload</span>
              </div> */}
          </Col>
        </Row>
        <Row className="profile-wrapper-data">
          {/* Left side box */}
          <Col lg={8} md={8} sm={12} xs={12} className="profile-data">
            <section className="company-profile-data">
              <div className="profile-header">
                <div className="profile-header__logo"></div>
                <div className="profile-header__name">Ambrosia</div>
              </div>
              <div className="profile-gen-info">
                <Row>
                  <Col lg={4} md={4} sm={4} xs={12} className="gy-2">
                    <span className="profile-gen-info__label">
                      Company size
                    </span>
                    <span className="profile-gen-info__value">23</span>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12} className="gy-2">
                    <span className="profile-gen-info__label">Industry</span>
                    <span className="profile-gen-info__value">Food</span>
                  </Col>
                  <Col lg={4} md={4} sm={4} xs={12} className="gy-2">
                    <span className="profile-gen-info__label">Founded</span>
                    <span className="profile-gen-info__value">1994</span>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12} className="gy-2">
                    <span className="profile-gen-info__label">Website</span>
                    <span className="profile-gen-info__value">website url</span>
                  </Col>
                </Row>
              </div>

              {/* About company */}
              <div className="profile-about">
                <div className="profile-about__header abt-header">
                  <div className="abt-header__title">About</div>
                  <div className="abt-header__edit"></div>
                </div>
                <div className="profile-about__content">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Curabitur tempus, elit a venenatis ornare, libero dui maximus
                  nulla, in dignissim ipsum eros ut orci. Proin bibendum, diam
                  eu faucibus feugiat, nunc metus ullamcorper ligula, at
                  consectetur ligula lorem auctor lacus. Aliquam suscipit lacus
                  odio, sed tincidunt sapien consectetur eu. Donec quis leo
                  fringilla, volutpat enim ut, hendrerit sapien. Aenean tempus
                  tempor est non eleifend. Proin cursus diam sit amet augue
                  auctor rhoncus. Sed rhoncus metus iaculis elit malesuada
                  ornare. Nullam ut auctor quam. In tristique dui eget dui
                  fermentum bibendum. Integer condimentum, dolor ut laoreet
                  lacinia, est elit feugiat mi, ut consectetur arcu diam et
                  arcu. Nulla felis nisl, commodo et tellus id, efficitur
                  pretium ex.
                </div>
              </div>

              {/* Mission vission */}
              <div className="mission-vision">
                <div className="mission-vision__header abt-header">
                  <div className="abt-header__title">Mission - Vision</div>
                  <div className="abt-header__edit"></div>
                </div>
                <div className="mission-vision__content">
                  <ul>
                    <li>
                      Mission: To offer a curated selection of stylish,
                      high-quality fashion that empowers individuals to express
                      their unique personality.
                    </li>
                    <li>
                      Vision: To become the leading boutique for trendsetting
                      fashion in the region, known for exceptional customer
                      service and a personalized shopping experience.
                    </li>
                  </ul>
                </div>
              </div>

              {/* Company history */}
              <div className="mission-vision">
                <div className="mission-vision__header abt-header">
                  <div className="abt-header__title">
                    Company History & Milestones
                  </div>
                  <div className="abt-header__edit"></div>
                </div>
                <div className="mission-vision__content">
                  <ul>
                    <li>
                      2018: Urban Elegance Boutique was founded in downtown
                      Springfield.
                    </li>
                    <li>
                      2019: Expanded product line to include exclusive designer
                      collaborations.
                    </li>
                    <li>
                      2020: Launched online store to reach a broader audience.
                    </li>
                    <li>
                      2021: Celebrated 3 years in business with a community
                      event and rebranding.
                    </li>
                  </ul>
                </div>
              </div>
            </section>
          </Col>
          {/* Right side box */}
          <Col lg={4} md={4} sm={12} xs={12} className="profile-contact-info">
            <section className="company-contact-other-data">
              {/* Address box */}
              <div className="address-box">
                <div className="address-box__header">
                  <div className="label">Address</div>
                  <div className="edit-icon"></div>
                </div>

                <div className="address-box__lines">
                  <ul>
                    <li>Location: Thiruvanathapuram, kerala</li>
                    <li>Address: Kowadiyar, Vellayambalam P O</li>
                    <li>Phone Number: +91 4345623463</li>
                    <li>Email: ambrosia@gmail.com</li>
                  </ul>
                </div>
              </div>

              {/* Map location box */}
              <div className="map-location-wrapper" ref={mapRef}></div>

              {/* Social media persence */}
              <div className="social-media-wrapper">
                <div className="social-media-wrapper__header">
                  <div className="label">Social Media</div>
                  <div className="edit-icon"></div>
                </div>
                <div className="social-media-wrapper__lines">
                  <ul>
                    <li>@ambrosia-fb</li>
                    <li>@ambrosia-insta</li>
                    <li>@ambrosia-twitter</li>
                    <li>@ambrosia-youtube</li>
                  </ul>
                </div>
              </div>
            </section>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default CompanyProfilePage;
